import BaseTableHead from '@material-ui/core/TableHead'

const TableHead = BaseTableHead

export default TableHead
